import React from 'react'
import { ListProvider } from './ListContext'

const ListContextProvider = ({ children }): JSX.Element => {
  return <ListProvider>{children}</ListProvider>
}

export default ListContextProvider
